export function isEqualsIgnoreCase(
  a: string | undefined | null,
  b: string | undefined | null,
) {
  return (
    (a || '').localeCompare(b || '', 'en-US', { sensitivity: 'base' }) === 0
  );
}

export function includesIgnoreCase(
  haystack: string[],
  needle: string | undefined | null,
) {
  return haystack.some((element) => isEqualsIgnoreCase(element, needle));
}

export const stringUtils = {
  arrayToCommaString: (array: string[] | number[]) => array.join(','),
  commaStringToArray: (commaString: string) =>
    commaString.split(',').map((item) => item.trim()),
};
